import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabBase } from '@core/base/tab.base';

@Component({
  selector: 'app-trip-expenses-tab',
  templateUrl: './trip-expenses-tab.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TripExpensesTabComponent extends TabBase {
  constructor() {
    super(inject(ActivatedRoute).parent!);
  }
}
